/**
 * LoadingSpinner Component
 * 
 * Reusable loading indicator with consistent styling and accessibility.
 * Displays an animated spinner with optional message.
 */
export default function LoadingSpinner({ 
  message = 'Loading...', 
  size = 'default',
  centered = true 
}) {
  const sizeClasses = {
    small: 'w-6 h-6 border-2',
    default: 'w-12 h-12 border-4',
    large: 'w-16 h-16 border-4',
  };

  const spinner = (
    <div role="status">
      <div 
        className={`animate-spin rounded-full ${sizeClasses[size]} border-primary border-t-transparent`}
        aria-hidden="true"
      />
      <span className="sr-only">{message}</span>
    </div>
  );

  if (centered) {
    return (
      <div className="flex justify-center items-center py-12">
        {spinner}
      </div>
    );
  }

  return spinner;
}
